import { useQuery } from "@tanstack/react-query";
import { fetchCustomerTimeline } from "../api/crm";
import type { CommunicationEvent } from "../../types/crm";

const PAGE_SIZE = 50;

interface UseCustomerTimelineOptions {
  source?: string;
  offset?: number;
}

/** Fetches a page of communication events for a customer.
 *  "Load more" pattern: caller increments offset by PAGE_SIZE and the
 *  result is accumulated externally in the component. */
export function useCustomerTimeline(
  id: string,
  { source, offset = 0 }: UseCustomerTimelineOptions = {},
) {
  return useQuery({
    queryKey: ["crm", "timeline", id, source, offset],
    queryFn: () =>
      fetchCustomerTimeline(id, {
        limit: PAGE_SIZE,
        offset,
        ...(source ? { source } : {}),
      }),
    staleTime: 2 * 60 * 1000, // 2 min
    gcTime: 10 * 60 * 1000,
    enabled: Boolean(id),
  });
}

export { PAGE_SIZE as TIMELINE_PAGE_SIZE };
export type { CommunicationEvent };
